export class AppSettings {
    public static SERVER_ENDPOINT='https://api.glasswing.in/';
    public static API_ENDPOINT='https://api.glasswing.in/api/';
    public static IMAGE_ENDPOINT='http://api.glasswing.in/api/images/';
 }
